const USERINFO_KEY = 'SCM_USERINFO';
const USERCID_KEY = 'SCM_CID_PC';

const isLogin = () => {
  return !!localStorage.getItem(USERINFO_KEY);
};

const getUserInfo = () => {
  const userInfo = localStorage.getItem(USERINFO_KEY);
  if (userInfo) {
    return JSON.parse(userInfo);
  }
  return userInfo;
};

const getUserCid = () => {
  return Number(localStorage.getItem(USERCID_KEY));
};

const setUserCid = (cid: number) => {
  return localStorage.setItem(USERCID_KEY, String(cid || ''));
};

// const getToken = () => {
//   return localStorage.getItem(TOKEN_KEY);
// };

const setUserInfo = (userinfo: any) => {
  localStorage.setItem(USERINFO_KEY, JSON.stringify(userinfo));
  setUserCid(userinfo?.cid);
};

const clearUserInfo = () => {
  localStorage.removeItem(USERINFO_KEY);
};

export { isLogin, getUserInfo, setUserInfo, clearUserInfo, getUserCid };
